<template>
    <el-dialog
        :title="data && data.name"
        :visible.sync="dialogVisible"
        center
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="close"
        width="800px"
        append-to-body
    >
        <div class="dialog-content">
            <div class="sr-descriptions horizontal">
                <div class="item">
                    <label>
                        <svg-icon icon-class="details_name"></svg-icon>
                        名称
                    </label>
                    <div class="text">{{ data.name }}</div>
                </div>
                <div class="item">
                    <label>
                        <svg-icon icon-class="details_lang"></svg-icon>
                        表演语言
                    </label>
                    <div class="text">{{ data.langCodeName }}</div>
                </div>
                <div class="item" v-if="data.artistFormat">
                    <label style="width: 100%;">
                        <svg-icon icon-class="name"></svg-icon>
                        艺人信息
                    </label>

                    <ArtistPlatformProgress
                        v-if="hasArtist"
                        :stats-data="thirdPartyPlatformStats"
                        :artist-progress-data="artistProgressData"
                        :is-editable="false"
                        :wrap-layout="true"
                        @handle-click="toReleaseArtistDrawer"
                    ></ArtistPlatformProgress>

                    <p style="padding: 0 16px 10px 10px; font-size: 12px; color: #c0c4cc;" v-if="hasArtist">
                        {{ artistProgressTip }}
                        <span
                            style="cursor: pointer; color: #188df7; margin-left: 10px; border: 1px solid #4d8cff; border-radius: 5px; padding: 5px 10px;"
                            @click="toReleaseArtistDrawer(true)"
                        >
                            查看平台艺人
                        </span>
                    </p>

                    <div class="text">
                        <p v-for="(artist, index) in data.artistFormat" :key="index">{{ artist }}</p>
                    </div>
                </div>
                <div class="item">
                    <label>
                        <svg-icon icon-class="details_style"></svg-icon>
                        流派/风格
                    </label>
                    <div class="text">{{ data.genreFormat }}</div>
                </div>
                <div class="item">
                    <label>
                        <svg-icon icon-class="ai_make"></svg-icon>
                        是否为AI生成
                    </label>
                    <div class="text">{{ data.isAiGenerated == 0 ? '否' : '是' }}</div>
                </div>
                <div class="item">
                    <label>
                        <svg-icon icon-class="yitixian"></svg-icon>
                        歌曲副标题
                    </label>
                    <div class="text">{{ data.trackVersion }}</div>
                </div>
                <div class="item">
                    <label>
                        <svg-icon icon-class="details_more"></svg-icon>
                        歌词文件
                    </label>
                    <div class="text">{{ data.materielName || '暂无' }}</div>
                    <el-button v-if="data.materielPath" type="text" class="underline" @click="download(data.materielPath, data.materielName)">
                        下载
                    </el-button>
                </div>
                <div class="item">
                    <label>
                        <svg-icon icon-class="link"></svg-icon>
                        歌曲源文件
                    </label>
                    <div class="text">{{ data.songFileName }}</div>
                    <el-button v-if="data.path" type="text" class="underline" @click="download(data.path, data.songFileName)">下载</el-button>
                </div>
            </div>
        </div>
        <album-release-dialog
            ref="albumReleaseDialogRef"
            :all-artist-info="allArtistInfo"
            :all-artist-value-options="allArtistValueOptions"
            :is-album="false"
            :display-lang-code="displayLangCode"
        ></album-release-dialog>
    </el-dialog>
</template>

<script>
import {downLoadByUri} from '@/api/file';
import {fetchListRelateArtist} from '@/api/album';
import AlbumReleaseDialog from '../AlbumRelease/AlbumReleaseDialog.vue';
import ArtistPlatformProgress from '../ArtistPlatformProgress/index.vue';

export default {
    components: {AlbumReleaseDialog, ArtistPlatformProgress},
    props: {
        displayLangCode: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            dialogVisible: false,
            data: {},
            allArtistInfo: [],
            allArtistValueOptions: [],
            artistProgressData: [],
            thirdPartyPlatformStats: []
        };
    },
    computed: {
        hasArtist() {
            return this.data.artistFormat && this.data.artistFormat.length > 0;
        },
        artistProgressTip() {
            return '建议提前关联各平台艺人主页，可减少作品进入错误主页的情况';
        }
    },
    methods: {
        show(vo) {
            this.thirdPartyPlatformStats = vo.thirdPartyPlatformStats || [];
            this.data = {...vo};
            // 艺人
            const artists = [];
            if (vo.trackArtists && vo.trackArtists.length > 0) {
                vo.trackArtists.forEach((item) => {
                    const type = item.typeName == '主要艺人' ? '演唱艺人' : item.typeName;
                    artists.push(`${item.artistName} -（${type}）`);
                });
            }
            this.data.artistFormat = artists;
            this.allArtistInfo = this.data?.trackArtists?.map((item) => ({
                    value: item.artistId,
                    name: item.artistName,
                    type: item.type,
                    appleId: item.appleId,
                    spotifyId: item.spotifyId,
                }));

                this.allArtistValueOptions = this.data?.trackArtists?.map((item) => ({
                    isRole: 0,
                    name: item.typeName,
                    value: item.type,
                }));
            // 歌词物料
            if (vo.trackLyrics && vo.trackLyrics.length > 0) {
                this.data.materielName = vo.trackLyrics[0].name;
                this.data.materielPath = vo.trackLyrics[0].path;
            }
            //风格
            this.data.genreFormat = vo.pGenreName + '/' + vo.genreName;

            // 歌曲文件名
            if (this.data.name && this.data.format) this.data.songFileName = this.data.name + '.' + this.data.format;

            this.fetchArtistProgress();
            this.dialogVisible = true;
        },
        /**
         * 获取艺人关联进度
         */
        async fetchArtistProgress() {
            if (!this.allArtistInfo || this.allArtistInfo.length === 0) {
                this.artistProgressData = [];
                return;
            }
            const ids = [...new Set(this.allArtistInfo.map(item => item.value).filter(Boolean))];
            if (ids.length === 0) {
                this.artistProgressData = [];
                return;
            }
            try {
                const res = await fetchListRelateArtist(ids);
                if (res.data && res.data.state) {
                    this.artistProgressData = res.data.result || [];
                }
            } catch (error) {
                console.error('获取艺人关联进度失败', error);
            }
        },
        close() {
            this.dialogVisible = false;
        },
        download(filePath, fileName) {
            downLoadByUri(filePath, fileName);
        },
        toReleaseArtistDrawer(isView = true) {
            this.$refs.albumReleaseDialogRef.open(isView);
        }
    },
};
</script>
